// src/components/ProjetosObra.jsx
import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import {
  FaSearch, FaPlus, FaEllipsisV, FaEnvelope, FaPhone,
  FaCalendarAlt, FaFileAlt, FaTimes, FaTrash, FaEdit, FaLink,
} from "react-icons/fa";
import { supabase } from "../supabaseClient";
import "./ProjetosObra.css";

// ── Ícones das disciplinas ──────────────────────────────────────────
import {
  FaBolt, FaTint, FaFireExtinguisher, FaTree, FaWindowMaximize,
  FaVideo, FaNetworkWired, FaMapMarkedAlt, FaCouch, FaDraftingCompass,
  FaBuilding, FaSnowflake,
} from "react-icons/fa";
import { FaElevator } from "react-icons/fa6";
import {
  GiConcreteBag, GiLightningTrio, GiGasStove, GiWaterSplash,
  GiBrickWall, GiDrill,
} from "react-icons/gi";
import { MdSettingsRemote } from "react-icons/md";

// ── STATUS_CONFIG reformulado ──────────────────────────────────────
const STATUS_CONFIG = {
  em_analise:         { label: "Em análise",            color: "#2563eb", bg: "#eff6ff", dot: "#2563eb" },
  desativado:         { label: "Desativado",            color: "#6b7280", bg: "#f3f4f6", dot: "#9ca3af" },
  recusado:           { label: "Recusado",              color: "#dc2626", bg: "#fef2f2", dot: "#dc2626" },
  liberado_obra:      { label: "Liberado para obra",    color: "#16a34a", bg: "#f0fdf4", dot: "#16a34a" },
  aprovado:           { label: "Aprovado",              color: "#0891b2", bg: "#ecfeff", dot: "#0891b2" },
  liberado_ressalvas: { label: "Liberado com ressalvas", color: "#d97706", bg: "#fffbeb", dot: "#d97706" },
};

// ── NOVO: helper seguro para status ────────────────────────────────
const getStatus = (key) => STATUS_CONFIG[key] || STATUS_CONFIG.em_analise;

// ── Mapa de ícones / disciplinas ────────────────────────────────────
const ICONES_PROJETO = {
  arquitetura:       { label: "Arquitetura",            Icon: FaDraftingCompass,  color: "#2563eb" },
  estrutura:         { label: "Estrutura",              Icon: GiConcreteBag,      color: "#6b7280" },
  fachada:           { label: "Fachada",                Icon: FaBuilding,         color: "#0ea5e9" },
  ar_condicionado:   { label: "Ar-condicionado",        Icon: FaSnowflake,        color: "#38bdf8" },
  eletrica:          { label: "Elétrica",               Icon: FaBolt,             color: "#f59e0b" },
  hidraulica:        { label: "Hidráulica",             Icon: FaTint,             color: "#3b82f6" },
  incendio:          { label: "Incêndio",               Icon: FaFireExtinguisher, color: "#dc2626" },
  spda:              { label: "SPDA",                   Icon: GiLightningTrio,    color: "#eab308" },
  gas:               { label: "Gás",                    Icon: GiGasStove,         color: "#f97316" },
  paisagismo:        { label: "Paisagismo",             Icon: FaTree,             color: "#16a34a" },
  impermeabilizacao: { label: "Impermeabilização",      Icon: GiWaterSplash,      color: "#0891b2" },
  alvenaria:         { label: "Alvenaria",              Icon: GiBrickWall,        color: "#b45309" },
  esquadrias:        { label: "Esquadrias",             Icon: FaWindowMaximize,   color: "#64748b" },
  elevadores:        { label: "Elevadores",             Icon: FaElevator,         color: "#7c3aed" },
  automacao:         { label: "Automação",              Icon: MdSettingsRemote,   color: "#9333ea" },
  cftv:              { label: "CFTV / Segurança",       Icon: FaVideo,            color: "#334155" },
  telecom:           { label: "Cabeamento / Telecom",   Icon: FaNetworkWired,     color: "#0d9488" },
  sondagem:          { label: "Sondagem / Fundação",    Icon: GiDrill,            color: "#78350f" },
  topografia:        { label: "Topografia",             Icon: FaMapMarkedAlt,     color: "#059669" },
  interiores:        { label: "Interiores",             Icon: FaCouch,            color: "#db2777" },
};

const getIconeProjeto = (key) => ICONES_PROJETO[key] || ICONES_PROJETO.arquitetura;

const CAMPO_ID_ENTIDADE = { project: "project_id", setor: "setor_id", workspace: "workspace_id" };

const formatMoeda = (v) => (v ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
const formatData = (d) => d ? new Date(d + "T00:00:00").toLocaleDateString("pt-BR") : "—";
const formatBytes = (b) => {
  if (!b) return "—";
  if (b < 1024 * 1024) return `${(b / 1024).toFixed(0)} KB`;
  return `${(b / (1024 * 1024)).toFixed(1)} MB`;
};
const formatarCnpj = (v) => {
  if (!v) return "—";
  const d = String(v).replace(/\D/g, "");
  if (d.length !== 14) return v;
  return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
};

export default function ProjetosObra({ entity, entityType, donoContainerId, usuarioId, membros = [], onOpenTask }) {
  const [projetos, setProjetos] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  const [historico, setHistorico] = useState([]);
  const [pagamentos, setPagamentos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busca, setBusca] = useState("");
  const [filtroStatusCard, setFiltroStatusCard] = useState(null);
  const [filtroResponsavel, setFiltroResponsavel] = useState(null);
  const [projetoSelecionadoId, setProjetoSelecionadoId] = useState(null);
  const [abaAtiva, setAbaAtiva] = useState("informacoes");
  const [showNovoProjeto, setShowNovoProjeto] = useState(false);
  const [showEditarProjeto, setShowEditarProjeto] = useState(false);
  const [showCadastroProjetista, setShowCadastroProjetista] = useState(false);
  const [excluindo, setExcluindo] = useState(false);
  const [uploadingDoc, setUploadingDoc] = useState(false);

  // ── Estados de comentários ─────────────────────────────────────
  const [comentariosPorProjeto, setComentariosPorProjeto] = useState({});
  const [comentariosCount, setComentariosCount] = useState({});
  const [carregandoComentarios, setCarregandoComentarios] = useState({});
  const [comentarioAberto, setComentarioAberto] = useState({});
  const [comentarioTemp, setComentarioTemp] = useState({});
  const [enviandoComentario, setEnviandoComentario] = useState({});

  // ── Estados de pagamentos ──────────────────────────────────────
  const [novoPagamento, setNovoPagamento] = useState({ descricao: "", etapa_vinculada: "", valor: "", data_prevista: "" });

  // ── Estados de tarefas vinculadas ──────────────────────────────
  const [tarefasVinculadas, setTarefasVinculadas] = useState([]);
  const [linkandoTarefa, setLinkandoTarefa] = useState(false);
  const [linkView, setLinkView] = useState("entidades");
  const [entidadesDisponiveis, setEntidadesDisponiveis] = useState([]);
  const [entidadeSelecionada, setEntidadeSelecionada] = useState(null);
  const [notasDisponiveis, setNotasDisponiveis] = useState([]);
  const [carregandoLink, setCarregandoLink] = useState(false);
  const [buscaLink, setBuscaLink] = useState("");

  // ── Informações da obra (dados do project pai) ─────────────────
  const [obraInfo, setObraInfo] = useState(null);

  const docInputRef = useRef(null);

  const campoId = CAMPO_ID_ENTIDADE[entityType] || "setor_id";

  // ── Carregar informações da obra (project pai) ─────────────────
  useEffect(() => {
    if (entityType !== "project" || !entity?.id) { setObraInfo(null); return; }
    supabase
      .from("projects")
      .select("razao_social, cnpj, endereco, numero, complemento, bairro, cidade, uf")
      .eq("id", entity.id)
      .single()
      .then(({ data }) => setObraInfo(data || null));
  }, [entityType, entity?.id]);

  const enderecoObra = obraInfo ? [
    [obraInfo.endereco, obraInfo.numero].filter(Boolean).join(", "),
    obraInfo.complemento,
    obraInfo.bairro,
    [obraInfo.cidade, obraInfo.uf].filter(Boolean).join(" - "),
  ].filter(Boolean).join(" · ") : "";

  // ── Carregar projetos da entidade ──────────────────────────────
  const carregarProjetos = useCallback(async () => {
    if (!entity?.id) return;
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from("projetos_obra")
        .select(`
          *,
          escritorios_projetistas ( id, nome_escritorio, tipo_projetos ),
          escritorio_membros:escritorio_contato_id ( id, nome, telefone, email, registro_profissional )
        `)
        .eq(campoId, entity.id)
        .order("created_at", { ascending: false });

      if (error) throw error;
      setProjetos(data || []);
      setProjetoSelecionadoId(prev => {
        if (prev && data?.some(p => p.id === prev)) return prev;
        return data?.[0]?.id ?? null;
      });

      const ids = (data || []).map(p => p.id);
      if (ids.length > 0) {
        const { data: comentariosExistentes } = await supabase
          .from("comentarios_projeto_obra")
          .select("projeto_obra_id")
          .in("projeto_obra_id", ids);
        const contagem = {};
        (comentariosExistentes || []).forEach(c => {
          contagem[c.projeto_obra_id] = (contagem[c.projeto_obra_id] || 0) + 1;
        });
        setComentariosCount(contagem);
      } else {
        setComentariosCount({});
      }
    } catch (err) {
      console.error("Erro ao carregar projetos:", err);
    } finally {
      setLoading(false);
    }
  }, [entity?.id, campoId]);

  useEffect(() => { carregarProjetos(); }, [carregarProjetos]);

  // ── Carregar detalhes do projeto selecionado ───────────────────
  const carregarDetalhes = useCallback(async (projetoId) => {
    if (!projetoId) {
      setDocumentos([]);
      setHistorico([]);
      setPagamentos([]);
      setTarefasVinculadas([]);
      return;
    }
    const [
      { data: docs },
      { data: hist },
      { data: pags },
      { data: vinc },
    ] = await Promise.all([
      supabase.from("documentos_projeto").select("*").eq("projeto_obra_id", projetoId).order("created_at", { ascending: false }),
      supabase.from("historico_projeto").select("*").eq("projeto_obra_id", projetoId).order("created_at", { ascending: false }),
      supabase.from("projetos_obra_pagamentos").select("*").eq("projeto_obra_id", projetoId).order("ordem", { ascending: true }),
      supabase.from("projetos_obra_notas_vinculadas").select("id, nota_id, notas(id, nome, tipo)").eq("projeto_obra_id", projetoId),
    ]);
    setDocumentos(docs || []);
    setHistorico(hist || []);
    setPagamentos(pags || []);
    setTarefasVinculadas((vinc || []).map(v => ({
      vinculoId: v.id,
      notaId: v.nota_id,
      nome: v.notas?.nome || "Tarefa vinculada",
      tipo: v.notas?.tipo,
    })));
  }, []);

  useEffect(() => { carregarDetalhes(projetoSelecionadoId); }, [projetoSelecionadoId, carregarDetalhes]);

  // ── Derivados ────────────────────────────────────────────────
  const contagens = useMemo(() => {
    const base = { todos: projetos.length };
    Object.keys(STATUS_CONFIG).forEach(key => {
      base[key] = projetos.filter(p => p.status === key).length;
    });
    return base;
  }, [projetos]);

  const projetosFiltrados = useMemo(() => {
    return projetos.filter(p => {
      const nomeEscritorio = p.escritorios_projetistas?.nome_escritorio || "";
      const nomeContato = p.escritorio_membros?.nome || "";
      const buscaLower = busca.toLowerCase();
      const bateBusca = !busca ||
        p.nome.toLowerCase().includes(buscaLower) ||
        nomeEscritorio.toLowerCase().includes(buscaLower) ||
        nomeContato.toLowerCase().includes(buscaLower);
      const bateStatus = !filtroStatusCard || p.status === filtroStatusCard;
      const bateResponsavel = !filtroResponsavel || p.responsavel_id === filtroResponsavel;
      return bateBusca && bateStatus && bateResponsavel;
    });
  }, [projetos, busca, filtroStatusCard, filtroResponsavel]);

  const projetoSelecionado = projetos.find(p => p.id === projetoSelecionadoId);

  // ── Resumo de pagamentos (compartilhado entre Informações e aba Pagamentos) ──
  const resumoPagamentos = useMemo(() => {
    const hoje = new Date().toISOString().split("T")[0];
    const valor = (p) => Number(p.valor || 0);
    const total = pagamentos.reduce((s, p) => s + valor(p), 0);
    const pago = pagamentos.filter(p => p.status_pagamento === "pago").reduce((s, p) => s + valor(p), 0);
    const pendentes = pagamentos
      .filter(p => p.status_pagamento !== "pago")
      .sort((a, b) => (a.data_prevista || "9999").localeCompare(b.data_prevista || "9999"));
    return {
      total,
      pago,
      pendente: total - pago,
      pct: total > 0 ? Math.round((pago / total) * 100) : 0,
      proximos: pendentes.slice(0, 3),
      atrasados: pendentes.filter(p => p.data_prevista && p.data_prevista < hoje).length,
      hoje,
    };
  }, [pagamentos]);

  // ── Trocar status ───────────────────────────────────────────────
  const handleTrocarStatus = async (novoStatus) => {
    if (!projetoSelecionado) return;
    const { error } = await supabase
      .from("projetos_obra")
      .update({ status: novoStatus })
      .eq("id", projetoSelecionado.id);
    if (error) { alert("Erro ao atualizar status."); return; }
    setProjetos(prev => prev.map(p => p.id === projetoSelecionado.id ? { ...p, status: novoStatus } : p));
    carregarDetalhes(projetoSelecionado.id);
  };

  // ── Upload de documento ─────────────────────────────────────────
  const handleUploadDocumento = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file || !projetoSelecionado) return;
    setUploadingDoc(true);
    try {
      const ext = file.name.split(".").pop();
      const path = `projetos-obra/${projetoSelecionado.id}/${Date.now()}.${ext}`;
      const { error: erroUpload } = await supabase.storage.from("documentos-projetos").upload(path, file);
      if (erroUpload) throw erroUpload;
      const { data: { publicUrl } } = supabase.storage.from("documentos-projetos").getPublicUrl(path);

      const { data: novoDoc, error } = await supabase
        .from("documentos_projeto")
        .insert([{
          projeto_obra_id: projetoSelecionado.id,
          nome: file.name,
          url: publicUrl,
          tamanho_bytes: file.size,
          mime_type: file.type,
          created_by: usuarioId,
        }])
        .select()
        .single();
      if (error) throw error;

      setDocumentos(prev => [novoDoc, ...prev]);
    } catch (err) {
      console.error("Erro ao subir documento:", err);
      alert("Erro ao enviar documento: " + err.message);
    } finally {
      setUploadingDoc(false);
    }
  };

  const handleRemoverDocumento = async (doc) => {
    if (!window.confirm(`Remover "${doc.nome}"?`)) return;
    const { error } = await supabase.from("documentos_projeto").delete().eq("id", doc.id);
    if (!error) setDocumentos(prev => prev.filter(d => d.id !== doc.id));
  };

  // ── Excluir projeto ─────────────────────────────────────────────
  const handleExcluirProjeto = async () => {
    if (!projetoSelecionado) return;
    const confirmado = window.confirm(
      `Tem certeza que deseja excluir o projeto "${projetoSelecionado.nome}"? Essa ação não pode ser desfeita e vai apagar também os documentos e o histórico vinculados a ele.`
    );
    if (!confirmado) return;

    setExcluindo(true);
    try {
      const { error } = await supabase.from("projetos_obra").delete().eq("id", projetoSelecionado.id);
      if (error) throw error;

      // ── CORRIGIDO: sem efeito colateral dentro do updater ─────
      const restantes = projetos.filter(p => p.id !== projetoSelecionado.id);
      setProjetos(restantes);
      setProjetoSelecionadoId(restantes[0]?.id ?? null);
    } catch (err) {
      console.error("Erro ao excluir projeto:", err);
      alert("Erro ao excluir projeto: " + err.message);
    } finally {
      setExcluindo(false);
    }
  };

  // ── Comentários ────────────────────────────────────────────────
  const carregarComentarios = async (projetoId) => {
    const { data, error } = await supabase
      .from("comentarios_projeto_obra")
      .select("*")
      .eq("projeto_obra_id", projetoId)
      .order("created_at", { ascending: true });
    if (error || !data?.length) return [];
    const userIds = [...new Set(data.map(c => c.usuario_id))];
    const { data: profiles } = await supabase.from("profiles").select("id, nome, nickname").in("id", userIds);
    const profilesMap = (profiles || []).reduce((acc, p) => { acc[p.id] = p.nickname || p.nome; return acc; }, {});
    return data.map(c => ({ ...c, autorNome: profilesMap[c.usuario_id] || "Usuário" }));
  };

  const abrirComentarios = async (projetoId) => {
    if (comentarioAberto[projetoId]) { setComentarioAberto(prev => ({ ...prev, [projetoId]: false })); return; }
    if (comentariosPorProjeto[projetoId] === undefined) {
      setCarregandoComentarios(prev => ({ ...prev, [projetoId]: true }));
      const lista = await carregarComentarios(projetoId);
      setComentariosPorProjeto(prev => ({ ...prev, [projetoId]: lista }));
      setCarregandoComentarios(prev => ({ ...prev, [projetoId]: false }));
    }
    setComentarioAberto(prev => ({ ...prev, [projetoId]: true }));
  };

  const enviarComentario = async (projetoId) => {
    const texto = comentarioTemp[projetoId]?.trim();
    if (!texto || !usuarioId || enviandoComentario[projetoId]) return;
    setEnviandoComentario(prev => ({ ...prev, [projetoId]: true }));
    try {
      const { data, error } = await supabase
        .from("comentarios_projeto_obra")
        .insert({ projeto_obra_id: projetoId, usuario_id: usuarioId, comentario: texto })
        .select()
        .single();
      if (error) throw error;
      const { data: perfil } = await supabase.from("profiles").select("nome, nickname").eq("id", usuarioId).single();
      const novoComentario = { ...data, autorNome: perfil?.nickname || perfil?.nome || "Você" };
      setComentariosPorProjeto(prev => ({ ...prev, [projetoId]: [...(prev[projetoId] || []), novoComentario] }));
      setComentariosCount(prev => ({ ...prev, [projetoId]: (prev[projetoId] || 0) + 1 }));
      setComentarioTemp(prev => ({ ...prev, [projetoId]: "" }));
    } catch (err) {
      console.error("Erro ao enviar comentário:", err);
      alert("Erro ao enviar comentário.");
    } finally {
      setEnviandoComentario(prev => ({ ...prev, [projetoId]: false }));
    }
  };

  const removerComentario = async (comentario, projetoId) => {
    if (comentario.usuario_id !== usuarioId) return;
    if (!window.confirm("Excluir este comentário?")) return;
    const { error } = await supabase.from("comentarios_projeto_obra").delete().eq("id", comentario.id);
    if (!error) {
      setComentariosPorProjeto(prev => ({ ...prev, [projetoId]: prev[projetoId].filter(c => c.id !== comentario.id) }));
      setComentariosCount(prev => ({ ...prev, [projetoId]: Math.max(0, (prev[projetoId] || 1) - 1) }));
    }
  };

  // ── Pagamentos ─────────────────────────────────────────────────
  const handleAdicionarPagamento = async () => {
    if (!novoPagamento.descricao.trim() || !projetoSelecionado) return;
    const payload = {
      projeto_obra_id: projetoSelecionado.id,
      descricao: novoPagamento.descricao.trim(),
      etapa_vinculada: novoPagamento.etapa_vinculada.trim() || null,
      valor: novoPagamento.valor ? Number(novoPagamento.valor) : 0,
      data_prevista: novoPagamento.data_prevista || null,
      status_pagamento: "pendente",
      ordem: pagamentos.length,
    };
    const { data, error } = await supabase.from("projetos_obra_pagamentos").insert([payload]).select().single();
    if (error) { alert("Erro ao adicionar pagamento: " + error.message); return; }
    setPagamentos(prev => [...prev, data]);
    setNovoPagamento({ descricao: "", etapa_vinculada: "", valor: "", data_prevista: "" });
  };

  const handleTogglePagamento = async (pagamento) => {
    const novoStatus = pagamento.status_pagamento === "pago" ? "pendente" : "pago";
    const dataPagamento = novoStatus === "pago" ? new Date().toISOString().split("T")[0] : null;
    const { error } = await supabase.from("projetos_obra_pagamentos")
      .update({ status_pagamento: novoStatus, data_pagamento: dataPagamento })
      .eq("id", pagamento.id);
    if (error) { alert("Erro ao atualizar pagamento."); return; }
    setPagamentos(prev => prev.map(p => p.id === pagamento.id ? { ...p, status_pagamento: novoStatus, data_pagamento: dataPagamento } : p));
  };

  const handleRemoverPagamento = async (pagamento) => {
    if (!window.confirm(`Remover pagamento "${pagamento.descricao}"?`)) return;
    const { error } = await supabase.from("projetos_obra_pagamentos").delete().eq("id", pagamento.id);
    if (!error) setPagamentos(prev => prev.filter(p => p.id !== pagamento.id));
  };

  // ── Tarefas vinculadas ────────────────────────────────────────
  const carregarEntidadesDisponiveis = useCallback(async () => {
    if (!donoContainerId) return;
    setCarregandoLink(true);
    try {
      const { data: projs } = await supabase
        .from("projects").select("id, name, photo_url")
        .eq("user_id", donoContainerId).eq("ativo", true).order("name");
      const { data: setores } = await supabase
        .from("setores").select("id, name")
        .eq("user_id", donoContainerId).eq("ativo", true).order("name");
      setEntidadesDisponiveis([
        ...(projs || []).map(p => ({ id: p.id, nome: p.name, tipo: "projeto", foto: p.photo_url || null })),
        ...(setores || []).map(s => ({ id: s.id, nome: s.name, tipo: "setor", foto: null })),
      ]);
    } finally {
      setCarregandoLink(false);
    }
  }, [donoContainerId]);

  const buscarNotasDaEntidade = useCallback(async (entidade) => {
    setCarregandoLink(true);
    try {
      const campoPilha = entidade.tipo === "projeto" ? "project_id" : "setor_id";
      const { data: pilhas } = await supabase.from("pilhas").select("id, title").eq(campoPilha, entidade.id);
      if (!pilhas?.length) {
        setNotasDisponiveis([]);
        setEntidadeSelecionada(entidade);
        setLinkView("notas");
        return;
      }
      const pilhasMap = pilhas.reduce((acc, p) => { acc[p.id] = p.title || "Pilha sem nome"; return acc; }, {});
      const { data: notas } = await supabase
        .from("notas").select("id, nome, tipo, pilha_id")
        .in("pilha_id", pilhas.map(p => p.id)).order("nome");
      setNotasDisponiveis((notas || []).map(n => ({ ...n, pilhaNome: pilhasMap[n.pilha_id] || "Sem pilha" })));
      setEntidadeSelecionada(entidade);
      setLinkView("notas");
    } finally {
      setCarregandoLink(false);
    }
  }, []);

  const linkarTarefa = async (nota) => {
    if (!projetoSelecionado) return;
    if (tarefasVinculadas.some(t => t.notaId === nota.id)) return;
    const { data, error } = await supabase
      .from("projetos_obra_notas_vinculadas")
      .insert({ projeto_obra_id: projetoSelecionado.id, nota_id: nota.id, criado_por: usuarioId })
      .select("id").single();
    if (error) { alert("Erro ao vincular tarefa."); return; }
    setTarefasVinculadas(prev => [...prev, { vinculoId: data.id, notaId: nota.id, nome: nota.nome, tipo: nota.tipo }]);
  };

  const removerVinculoTarefa = async (vinculoId) => {
    if (!window.confirm("Remover vínculo com esta tarefa?")) return;
    const { error } = await supabase.from("projetos_obra_notas_vinculadas").delete().eq("id", vinculoId);
    if (!error) setTarefasVinculadas(prev => prev.filter(t => t.vinculoId !== vinculoId));
  };

  const abrirLinkTarefa = () => {
    setLinkandoTarefa(true);
    setLinkView("entidades");
    setEntidadeSelecionada(null);
    setNotasDisponiveis([]);
    setBuscaLink("");
    carregarEntidadesDisponiveis();
  };

  if (loading) {
    return <div className="projetos-obra-loading">Carregando projetos...</div>;
  }

  return (
    <div className="projetos-obra-page">
      {/* ── Input file GLOBAL (fora das abas) ── */}
      <input
        ref={docInputRef}
        type="file"
        style={{ display: "none" }}
        onChange={handleUploadDocumento}
      />

      {/* ── Coluna esquerda: lista ── */}
      <div className="projetos-obra-lista">
        <div className="projetos-obra-header">
          <div>
            {obraInfo && (
              <div className="po-obra-info">
                <div className="po-obra-info-item">
                  <span className="po-obra-info-lbl">Razão social</span>
                  <span className="po-obra-info-val" title={obraInfo.razao_social || ""}>{obraInfo.razao_social || "—"}</span>
                </div>
                <div className="po-obra-info-item">
                  <span className="po-obra-info-lbl">CNPJ</span>
                  <span className="po-obra-info-val">{formatarCnpj(obraInfo.cnpj)}</span>
                </div>
                <div className="po-obra-info-item po-obra-info-item--wide">
                  <span className="po-obra-info-lbl">Endereço</span>
                  <span className="po-obra-info-val" title={enderecoObra}>{enderecoObra || "—"}</span>
                </div>
              </div>
            )}
            <h1>Projetos da Obra</h1>
            <select
              className="po-filtro-responsavel"
              value={filtroResponsavel || ""}
              onChange={e => setFiltroResponsavel(e.target.value || null)}
            >
              <option value="">Todos os responsáveis</option>
              {membros.map(m => (
                <option key={m.id} value={m.id}>{m.nickname || "Sem nome"}</option>
              ))}
            </select>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button className="projetos-obra-projetista-btn" onClick={() => setShowCadastroProjetista(true)}>
              <FaPlus size={12} /> Cadastro projetista
            </button>
            <button className="projetos-obra-novo-btn" onClick={() => setShowNovoProjeto(true)}>
              <FaPlus size={12} /> Novo projeto
            </button>
          </div>
        </div>

        {/* ── Cards de status dinâmicos ── */}
        <div className="projetos-obra-stats" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))" }}>
          <div className={`po-stat-card${!filtroStatusCard ? " po-stat-card--ativo" : ""}`}
            onClick={() => setFiltroStatusCard(null)}>
            <div>
              <span className="po-stat-valor">{contagens.todos}</span>
              <span className="po-stat-label">Todos</span>
            </div>
          </div>
          {Object.entries(STATUS_CONFIG).map(([key, cfg]) => (
            <div key={key} className={`po-stat-card${filtroStatusCard === key ? " po-stat-card--ativo" : ""}`}
              onClick={() => setFiltroStatusCard(prev => prev === key ? null : key)}>
              <span className="po-stat-dot" style={{ background: cfg.dot }} />
              <div>
                <span className="po-stat-valor">{contagens[key] || 0}</span>
                <span className="po-stat-label">{cfg.label}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="projetos-obra-filtros">
          <div className="po-busca">
            <FaSearch size={12} />
            <input type="text" placeholder="Buscar projeto..." value={busca} onChange={e => setBusca(e.target.value)} />
          </div>
        </div>

        {projetosFiltrados.length === 0 ? (
          <div className="projetos-obra-vazio">
            {projetos.length === 0 ? "Nenhum projeto cadastrado ainda." : "Nenhum projeto encontrado com esse filtro."}
          </div>
        ) : (
          <table className="projetos-obra-tabela">
            <thead>
              <tr>
                <th>Projeto</th>
                <th>Escritório / Contato</th>
                <th>Valor total</th>
                <th>Status</th>
                <th></th>
                <th style={{ width: 50 }}></th>
              </tr>
            </thead>
            <tbody>
              {projetosFiltrados.map(p => {
                const st = getStatus(p.status);
                const selecionado = p.id === projetoSelecionadoId;
                const { Icon, color } = getIconeProjeto(p.icone);
                const numComentarios = comentariosCount[p.id] || 0;
                const comentarios = comentariosPorProjeto[p.id] || [];
                return (
                  <tr
                    key={p.id}
                    className={selecionado ? "po-row--selecionada" : ""}
                    style={{ borderLeft: `3px solid ${color}` }}
                    onClick={() => { setProjetoSelecionadoId(p.id); setAbaAtiva("informacoes"); }}
                  >
                    <td>
                      <div className="po-projeto-nome">
                        <span className="po-projeto-icone" style={{ background: `${color}1a`, color }}>
                          <Icon size={14} />
                        </span>
                        {p.nome}
                      </div>
                    </td>
                    <td>
                      <div className="po-projetista">
                        <span>{p.escritorios_projetistas?.nome_escritorio || "—"}</span>
                        {p.escritorio_membros?.nome && (
                          <small>{p.escritorio_membros.nome}{p.escritorio_membros.email ? ` · ${p.escritorio_membros.email}` : ""}</small>
                        )}
                      </div>
                    </td>
                    <td>{formatMoeda(p.valor_total)}</td>
                    <td><span className="po-status-badge" style={{ color: st.color, background: st.bg }}>{st.label}</span></td>
                    <td onClick={e => e.stopPropagation()} style={{ position: "relative" }}>
                      <span
                        className="po-comentario-btn"
                        style={{ color: numComentarios > 0 ? "#10b981" : "#9ca3af" }}
                        onClick={() => abrirComentarios(p.id)}
                        title="Comentários"
                      >
                        {carregandoComentarios[p.id] ? (
                          <span className="spinner-comentario" />
                        ) : (
                          <>
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                            </svg>
                            {numComentarios > 0 && <span className="po-comentario-badge">{numComentarios > 99 ? "99+" : numComentarios}</span>}
                          </>
                        )}
                      </span>

                      {comentarioAberto[p.id] && (
                        <div className="po-comentario-popover" onClick={e => e.stopPropagation()}>
                          <div className="po-comentario-input-area">
                            <input
                              type="text"
                              value={comentarioTemp[p.id] || ""}
                              onChange={e => setComentarioTemp(prev => ({ ...prev, [p.id]: e.target.value }))}
                              placeholder="Adicionar comentário..."
                              disabled={enviandoComentario[p.id]}
                              onKeyDown={e => { if (e.key === "Enter" && !enviandoComentario[p.id]) enviarComentario(p.id); }}
                            />
                            <button onClick={() => enviarComentario(p.id)} disabled={!comentarioTemp[p.id]?.trim() || enviandoComentario[p.id]}>
                              ➤
                            </button>
                          </div>
                          {comentarios.length === 0 ? (
                            <p className="po-comentario-vazio">Nenhum comentário ainda.</p>
                          ) : (
                            <div className="po-comentario-lista">
                              {[...comentarios].reverse().map(c => (
                                <div key={c.id} className="po-comentario-item">
                                  <div className="po-comentario-item-header">
                                    <span>{c.autorNome}</span>
                                    {c.usuario_id === usuarioId && (
                                      <button onClick={() => removerComentario(c, p.id)}>×</button>
                                    )}
                                  </div>
                                  <div className="po-comentario-texto">{c.comentario}</div>
                                  <div className="po-comentario-data">
                                    {new Date(c.created_at).toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}

        <div className="projetos-obra-paginacao">
          <span>Mostrando {projetosFiltrados.length} de {projetos.length} projetos</span>
        </div>
      </div>

      {/* ── Coluna direita: detalhe ── */}
      {projetoSelecionado && (
        <div className="projetos-obra-detalhe">
          <div className="po-detalhe-header">
            <div
              className="po-detalhe-icone"
              style={{
                background: `${getIconeProjeto(projetoSelecionado.icone).color}1a`,
                color: getIconeProjeto(projetoSelecionado.icone).color,
              }}
            >
              {(() => { const { Icon } = getIconeProjeto(projetoSelecionado.icone); return <Icon size={20} />; })()}
            </div>
            <div className="po-detalhe-header-info">
              <h2>Projeto {projetoSelecionado.nome}</h2>
              <select
                className="po-status-select"
                value={STATUS_CONFIG[projetoSelecionado.status] ? projetoSelecionado.status : "em_analise"}
                onChange={e => handleTrocarStatus(e.target.value)}
                style={{
                  color: getStatus(projetoSelecionado.status).color,
                  background: getStatus(projetoSelecionado.status).bg,
                }}
              >
                {Object.entries(STATUS_CONFIG).map(([key, cfg]) => (
                  <option key={key} value={key}>{cfg.label}</option>
                ))}
              </select>
            </div>

            <span
              className="obj-icon-btn"
              style={{ color: tarefasVinculadas.length > 0 ? "#10b981" : "#9ca3af", cursor: "pointer", marginRight: 8 }}
              title="Vincular tarefas externas"
              onClick={abrirLinkTarefa}
            >
              <FaLink size={13} />
            </span>

            <button className="po-editar-btn" onClick={() => setShowEditarProjeto(true)} title="Editar projeto">
              <FaEdit size={13} />
            </button>
          </div>

          <div className="po-detalhe-tabs">
            {["informacoes", "documentos", "pagamentos", "historico"].map(tab => (
              <button key={tab} className={abaAtiva === tab ? "po-tab--ativa" : ""} onClick={() => setAbaAtiva(tab)}>
                {tab === "informacoes" ? "Informações"
                  : tab === "documentos" ? "Documentos"
                  : tab === "pagamentos" ? "Pagamentos"
                  : "Histórico"}
              </button>
            ))}
          </div>

          {abaAtiva === "informacoes" && (
            <div className="po-detalhe-conteudo">
              <div className="po-info-item">
                <span className="po-info-label">Escritório</span>
                <span className="po-info-valor">{projetoSelecionado.escritorios_projetistas?.nome_escritorio || "—"}</span>
              </div>
              <div className="po-info-item">
                <span className="po-info-label">Contato responsável</span>
                <span className="po-info-valor">{projetoSelecionado.escritorio_membros?.nome || "—"}</span>
              </div>
              {(projetoSelecionado.escritorio_membros?.email || projetoSelecionado.escritorio_membros?.telefone) && (
                <div className="po-info-item">
                  <span className="po-info-label">Contato</span>
                  {projetoSelecionado.escritorio_membros?.email && (
                    <span className="po-info-valor po-contato"><FaEnvelope size={11} /> {projetoSelecionado.escritorio_membros.email}</span>
                  )}
                  {projetoSelecionado.escritorio_membros?.telefone && (
                    <span className="po-info-valor po-contato"><FaPhone size={11} /> {projetoSelecionado.escritorio_membros.telefone}</span>
                  )}
                </div>
              )}
              <div className="po-info-item">
                <span className="po-info-label">Valor total</span>
                <span className="po-info-valor po-valor-destaque">{formatMoeda(projetoSelecionado.valor_total)}</span>
              </div>
              <div className="po-info-item">
                <span className="po-info-label">Prazo</span>
                <span className="po-info-valor"><FaCalendarAlt size={11} /> {formatData(projetoSelecionado.prazo_inicio)} → {formatData(projetoSelecionado.prazo_fim)}</span>
              </div>

              <div className="po-mini-secao">
                <div className="po-mini-secao-header">
                  <span>Documentos</span>
                  <button className="po-add-btn" onClick={() => docInputRef.current?.click()} disabled={uploadingDoc}>
                    <FaPlus size={10} /> {uploadingDoc ? "Enviando..." : "Adicionar"}
                  </button>
                </div>
                {documentos.length === 0 ? (
                  <p className="po-vazio-mini">Nenhum documento enviado.</p>
                ) : (
                  documentos.slice(0, 3).map(doc => (
                    <div key={doc.id} className="po-doc-item">
                      <a href={doc.url} target="_blank" rel="noopener noreferrer" className="po-doc-link">
                        <FaFileAlt className="po-doc-icon" />
                        <div>
                          <span className="po-doc-nome" title={doc.nome}>{doc.nome}</span>
                          <span className="po-doc-meta">{formatBytes(doc.tamanho_bytes)} · {formatData(doc.created_at?.split("T")[0])}</span>
                        </div>
                      </a>
                      <button className="po-row-menu" onClick={() => handleRemoverDocumento(doc)}><FaTrash size={11} /></button>
                    </div>
                  ))
                )}
              </div>

              <div className="po-mini-secao">
                <div className="po-mini-secao-header">
                  <span>Pagamentos</span>
                  <button className="po-add-btn" onClick={() => setAbaAtiva("pagamentos")}>Ver todos</button>
                </div>
                {pagamentos.length === 0 ? (
                  <p className="po-vazio-mini">Nenhum pagamento cadastrado.</p>
                ) : (
                  <>
                    <div className="po-pag-barra"><div className="po-pag-barra-fill" style={{ width: `${resumoPagamentos.pct}%` }} /></div>
                    <div className="po-pag-mini-linha">
                      <span><strong>{formatMoeda(resumoPagamentos.pago)}</strong> pagos de {formatMoeda(resumoPagamentos.total)}</span>
                      <span>{resumoPagamentos.pct}%</span>
                    </div>
                    {resumoPagamentos.atrasados > 0 && (
                      <p className="po-pag-alerta">⚠ {resumoPagamentos.atrasados} pagamento{resumoPagamentos.atrasados > 1 ? "s" : ""} em atraso</p>
                    )}
                    {resumoPagamentos.proximos.map(p => (
                      <div key={p.id} className="po-pag-mini-item">
                        <div className="po-pag-mini-info">
                          <span className="po-doc-nome" title={p.descricao}>{p.descricao}</span>
                          <span className="po-doc-meta">previsto {formatData(p.data_prevista)}</span>
                        </div>
                        <span className="po-pag-mini-valor">{formatMoeda(p.valor)}</span>
                      </div>
                    ))}
                  </>
                )}
              </div>

              <div className="po-mini-secao">
                <span className="po-mini-secao-header"><span>Tarefas vinculadas</span></span>
                {tarefasVinculadas.length === 0 ? (
                  <p className="po-vazio-mini">Nenhuma tarefa vinculada.</p>
                ) : (
                  tarefasVinculadas.map(t => (
                    <div key={t.vinculoId} className="po-doc-item">
                      <div className="po-doc-link" style={{ cursor: "pointer" }} onClick={() => onOpenTask && onOpenTask(t.notaId)}>
                        <FaFileAlt className="po-doc-icon" />
                        <div><span className="po-doc-nome" title={t.nome}>{t.nome}</span></div>
                      </div>
                      <button className="po-row-menu" onClick={() => removerVinculoTarefa(t.vinculoId)}><FaTrash size={11} /></button>
                    </div>
                  ))
                )}
              </div>

              <div className="po-mini-secao">
                <span className="po-mini-secao-header"><span>Histórico</span></span>
                {historico.length === 0 ? (
                  <p className="po-vazio-mini">Sem eventos registrados ainda.</p>
                ) : (
                  <div className="po-timeline">
                    {historico.slice(0, 4).map(h => (
                      <div key={h.id} className="po-timeline-item">
                        <span className={`po-timeline-dot po-timeline-dot--${h.status}`} />
                        <div>
                          <span className="po-timeline-titulo">{h.titulo}</span>
                          <span className="po-timeline-data">
                            {new Date(h.created_at).toLocaleDateString("pt-BR")}
                            {h.autor_nome ? ` · ${h.autor_nome}` : ""}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {documentos.length > 3 && (
                <button className="po-ver-todos-btn" onClick={() => setAbaAtiva("documentos")}>
                  Ver todos os documentos
                </button>
              )}

              <button className="po-excluir-btn" onClick={handleExcluirProjeto} disabled={excluindo}>
                <FaTrash size={12} /> {excluindo ? "Excluindo..." : "Excluir projeto"}
              </button>
            </div>
          )}

          {abaAtiva === "documentos" && (
            <div className="po-detalhe-conteudo">
              <div className="po-mini-secao-header">
                <span>Todos os documentos ({documentos.length})</span>
                <button className="po-add-btn" onClick={() => docInputRef.current?.click()} disabled={uploadingDoc}>
                  <FaPlus size={10} /> {uploadingDoc ? "Enviando..." : "Adicionar"}
                </button>
              </div>
              {documentos.length === 0 ? (
                <p className="po-vazio-mini">Nenhum documento enviado.</p>
              ) : (
                documentos.map(doc => (
                  <div key={doc.id} className="po-doc-item">
                    <a href={doc.url} target="_blank" rel="noopener noreferrer" className="po-doc-link">
                      <FaFileAlt className="po-doc-icon" />
                      <div>
                        <span className="po-doc-nome" title={doc.nome}>{doc.nome}</span>
                        <span className="po-doc-meta">{formatBytes(doc.tamanho_bytes)} · {formatData(doc.created_at?.split("T")[0])}</span>
                      </div>
                    </a>
                    <button className="po-row-menu" onClick={() => handleRemoverDocumento(doc)}><FaTrash size={11} /></button>
                  </div>
                ))
              )}
            </div>
          )}

          {abaAtiva === "pagamentos" && (
            <div className="po-detalhe-conteudo">
              {pagamentos.length > 0 && (
                <div className="po-pag-resumo">
                  <div className="po-pag-resumo-grid">
                    <div><span className="po-pag-lbl">Pago</span><strong className="po-pag-pago">{formatMoeda(resumoPagamentos.pago)}</strong></div>
                    <div><span className="po-pag-lbl">Pendente</span><strong>{formatMoeda(resumoPagamentos.pendente)}</strong></div>
                    <div><span className="po-pag-lbl">Total</span><strong>{formatMoeda(resumoPagamentos.total)}</strong></div>
                  </div>
                  <div className="po-pag-barra"><div className="po-pag-barra-fill" style={{ width: `${resumoPagamentos.pct}%` }} /></div>
                  <span className="po-pag-pct">{resumoPagamentos.pct}% pago</span>
                </div>
              )}

              {pagamentos.length === 0 ? (
                <p className="po-vazio-mini">Nenhum pagamento cadastrado.</p>
              ) : (
                <div className="po-pag-lista">
                  {pagamentos.map(p => {
                    const pago = p.status_pagamento === "pago";
                    const atrasado = !pago && p.data_prevista && p.data_prevista < resumoPagamentos.hoje;
                    return (
                      <div key={p.id} className={`po-pag-item${pago ? " po-pag-item--pago" : ""}${atrasado ? " po-pag-item--atrasado" : ""}`}>
                        <input type="checkbox" className="po-pag-check" checked={pago} onChange={() => handleTogglePagamento(p)} />
                        <div className="po-pag-info">
                          <span className="po-pag-desc" title={p.descricao}>{p.descricao}</span>
                          {p.etapa_vinculada && <span className="po-pag-etapa">{p.etapa_vinculada}</span>}
                          <span className="po-pag-meta">
                            {pago ? `Pago em ${formatData(p.data_pagamento)}` : `Previsto ${formatData(p.data_prevista)}`}
                          </span>
                        </div>
                        <div className="po-pag-direita">
                          <span className="po-pag-valor">{formatMoeda(p.valor)}</span>
                          <span className={`po-pag-badge ${pago ? "po-pag-badge--pago" : atrasado ? "po-pag-badge--atrasado" : "po-pag-badge--pendente"}`}>
                            {pago ? "Pago" : atrasado ? "Atrasado" : "Pendente"}
                          </span>
                        </div>
                        <button className="po-row-menu" onClick={() => handleRemoverPagamento(p)} title="Remover"><FaTrash size={11} /></button>
                      </div>
                    );
                  })}
                </div>
              )}

              <div className="po-pag-form">
                <span className="po-pag-form-titulo">Novo pagamento</span>
                <input type="text" placeholder="Descrição (ex: Entrega do projeto executivo)"
                  value={novoPagamento.descricao} onChange={e => setNovoPagamento(p => ({ ...p, descricao: e.target.value }))} />
                <input type="text" placeholder="Etapa vinculada (opcional)"
                  value={novoPagamento.etapa_vinculada} onChange={e => setNovoPagamento(p => ({ ...p, etapa_vinculada: e.target.value }))} />
                <div className="po-pag-form-row">
                  <input type="number" placeholder="Valor (R$)"
                    value={novoPagamento.valor} onChange={e => setNovoPagamento(p => ({ ...p, valor: e.target.value }))} />
                  <input type="date" value={novoPagamento.data_prevista}
                    onChange={e => setNovoPagamento(p => ({ ...p, data_prevista: e.target.value }))} />
                </div>
                <button type="button" className="po-pag-form-btn" onClick={handleAdicionarPagamento} disabled={!novoPagamento.descricao.trim()}>
                  <FaPlus size={10} /> Adicionar pagamento
                </button>
              </div>
            </div>
          )}

          {abaAtiva === "historico" && (
            <div className="po-detalhe-conteudo">
              {historico.length === 0 ? (
                <p className="po-vazio-mini">Sem eventos registrados ainda.</p>
              ) : (
                <div className="po-timeline">
                  {historico.map(h => (
                    <div key={h.id} className="po-timeline-item">
                      <span className={`po-timeline-dot po-timeline-dot--${h.status}`} />
                      <div>
                        <span className="po-timeline-titulo">{h.titulo}</span>
                        <span className="po-timeline-data">
                          {new Date(h.created_at).toLocaleDateString("pt-BR")}
                          {h.autor_nome ? ` · ${h.autor_nome}` : ""}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {showNovoProjeto && (
        <NovoProjetoModal
          entity={entity}
          campoId={campoId}
          donoContainerId={donoContainerId}
          usuarioId={usuarioId}
          membros={membros}
          onClose={() => setShowNovoProjeto(false)}
          onCriado={(novo) => {
            setProjetos(prev => [novo, ...prev]);
            setProjetoSelecionadoId(novo.id);
            setShowNovoProjeto(false);
          }}
        />
      )}

      {showEditarProjeto && projetoSelecionado && (
        <EditarProjetoModal
          projeto={projetoSelecionado}
          campoId={campoId}
          donoContainerId={donoContainerId}
          membros={membros}
          onClose={() => setShowEditarProjeto(false)}
          onAtualizado={(atualizado) => {
            setProjetos(prev => prev.map(p => p.id === atualizado.id ? atualizado : p));
            setShowEditarProjeto(false);
          }}
        />
      )}

      {showCadastroProjetista && (
        <CadastroProjetistaModal
          donoContainerId={donoContainerId}
          usuarioId={usuarioId}
          onClose={() => setShowCadastroProjetista(false)}
        />
      )}

      {linkandoTarefa && (
        <div className="modal-linkar-nota-overlay" onClick={() => setLinkandoTarefa(false)}>
          <div className="modal-linkar-nota-box" onClick={e => e.stopPropagation()}>
            <div className="modal-linkar-nota-header">
              <span>
                {linkView === "notas" && (
                  <button
                    className="modal-linkar-nota-voltar"
                    onClick={() => { setLinkView("entidades"); setEntidadeSelecionada(null); setBuscaLink(""); }}
                  >
                    ←
                  </button>
                )}
                {linkView === "entidades" ? "Selecione o projeto/setor" : `Tarefas em: ${entidadeSelecionada?.nome}`}
              </span>
              <button onClick={() => setLinkandoTarefa(false)}>×</button>
            </div>

            {!carregandoLink && (entidadesDisponiveis.length > 0 || notasDisponiveis.length > 0) && (
              <div className="modal-linkar-nota-busca">
                <input
                  type="text"
                  autoFocus
                  placeholder={linkView === "entidades" ? "Buscar projeto ou setor..." : "Buscar tarefa..."}
                  value={buscaLink}
                  onChange={e => setBuscaLink(e.target.value)}
                />
              </div>
            )}

            {carregandoLink ? (
              <div className="modal-linkar-nota-loading">Carregando...</div>
            ) : linkView === "entidades" ? (
              <div className="modal-linkar-nota-lista">
                {entidadesDisponiveis
                  .filter(e => e.nome.toLowerCase().includes(buscaLink.toLowerCase()))
                  .map(ent => (
                    <button
                      key={`${ent.tipo}-${ent.id}`}
                      className="modal-linkar-nota-item modal-linkar-nota-item--entidade"
                      onClick={() => buscarNotasDaEntidade(ent)}
                    >
                      <div className="modal-linkar-nota-entidade-info">
                        <div className="modal-linkar-nota-nome">{ent.nome}</div>
                        <div className="modal-linkar-nota-tipo">{ent.tipo === "projeto" ? "Projeto" : "Setor"}</div>
                      </div>
                    </button>
                  ))}
              </div>
            ) : (
              <div className="modal-linkar-nota-lista">
                {notasDisponiveis
                  .filter(n => n.nome.toLowerCase().includes(buscaLink.toLowerCase()))
                  .map(nota => {
                    const jaVinculada = tarefasVinculadas.some(t => t.notaId === nota.id);
                    return (
                      <button
                        key={nota.id}
                        className={`modal-linkar-nota-item ${jaVinculada ? "modal-linkar-nota-item--vinculada" : ""}`}
                        onClick={() => !jaVinculada && linkarTarefa(nota)}
                        disabled={jaVinculada}
                      >
                        <div className="modal-linkar-nota-nome">{nota.nome}</div>
                        <div className="modal-linkar-nota-classificacao">{nota.pilhaNome}</div>
                        <div className="modal-linkar-nota-tipo">{jaVinculada ? "✓ Já vinculada" : nota.tipo}</div>
                      </button>
                    );
                  })}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// ============================================================
// Modal: Novo Projeto
// ============================================================
function NovoProjetoModal({ entity, campoId, donoContainerId, usuarioId, membros = [], onClose, onCriado }) {
  const [nome, setNome] = useState("");
  const [icone, setIcone] = useState("arquitetura");
  const [etapa, setEtapa] = useState("");
  const [status, setStatus] = useState("em_analise");
  const [valorTotal, setValorTotal] = useState("");
  const [prazoInicio, setPrazoInicio] = useState("");
  const [prazoFim, setPrazoFim] = useState("");
  const [responsavelId, setResponsavelId] = useState(null);

  const [escritorios, setEscritorios] = useState([]);
  const [escritorioId, setEscritorioId] = useState("");
  const [membrosDoEscritorio, setMembrosDoEscritorio] = useState([]);
  const [contatoId, setContatoId] = useState("");

  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    const carregar = async () => {
      if (!donoContainerId) return;
      const { data } = await supabase
        .from("escritorios_projetistas")
        .select("*, escritorio_membros(*)")
        .eq("container_id", donoContainerId)
        .order("nome_escritorio");
      setEscritorios(data || []);
    };
    carregar();
  }, [donoContainerId]);

  useEffect(() => {
    const esc = escritorios.find(e => e.id === Number(escritorioId));
    setMembrosDoEscritorio(esc?.escritorio_membros || []);
  }, [escritorioId, escritorios]);

  const handleSalvar = async () => {
    if (!nome.trim()) { alert("Digite o nome do projeto."); return; }
    if (!donoContainerId) { alert("Container não identificado."); return; }
    setSalvando(true);
    try {
      const payload = {
        nome: nome.trim(),
        icone,
        etapa: etapa.trim() || "Não iniciado",
        status,
        valor_total: valorTotal ? Number(valorTotal) : 0,
        prazo_inicio: prazoInicio || null,
        prazo_fim: prazoFim || null,
        escritorio_id: escritorioId ? Number(escritorioId) : null,
        escritorio_contato_id: contatoId ? Number(contatoId) : null,
        responsavel_id: responsavelId,
        container_id: donoContainerId,
        created_by: usuarioId,
        [campoId]: entity.id,
      };

      const { data: novo, error } = await supabase
        .from("projetos_obra")
        .insert([payload])
        .select(`
          *,
          escritorios_projetistas ( id, nome_escritorio, tipo_projetos ),
          escritorio_membros:escritorio_contato_id ( id, nome, telefone, email, registro_profissional )
        `)
        .single();
      if (error) throw error;

      onCriado(novo);
    } catch (err) {
      console.error("Erro ao criar projeto:", err);
      alert("Erro ao criar projeto: " + err.message);
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div className="po-modal-overlay" onClick={onClose}>
      <div className="po-modal-content" onClick={e => e.stopPropagation()}>
        <div className="po-modal-header">
          <h3>Novo projeto</h3>
          <button onClick={onClose}><FaTimes /></button>
        </div>

        <div className="po-modal-body">
          <label>Nome do projeto</label>
          <input type="text" value={nome} onChange={e => setNome(e.target.value)} placeholder="Ex: Arquitetônico" autoFocus />

          <label>Ícone / Disciplina</label>
          <div className="po-icone-grid">
            {Object.entries(ICONES_PROJETO).map(([key, { label, Icon, color }]) => (
              <button
                key={key}
                type="button"
                className={`po-icone-opcao${icone === key ? " po-icone-opcao--ativa" : ""}`}
                style={{ "--icone-cor": color }}
                onClick={() => setIcone(key)}
                title={label}
              >
                <Icon size={16} />
                <span>{label}</span>
              </button>
            ))}
          </div>

          <div className="po-modal-row">
            <div>
              <label>Etapa</label>
              <input type="text" value={etapa} onChange={e => setEtapa(e.target.value)} placeholder="Ex: Desenvolvimento" />
            </div>
            <div>
              <label>Status</label>
              <select value={status} onChange={e => setStatus(e.target.value)}>
                {Object.entries(STATUS_CONFIG).map(([key, cfg]) => (
                  <option key={key} value={key}>{cfg.label}</option>
                ))}
              </select>
            </div>
          </div>

          <label>Valor total (R$)</label>
          <input type="number" value={valorTotal} onChange={e => setValorTotal(e.target.value)} placeholder="0,00" />

          <div className="po-modal-row">
            <div>
              <label>Início</label>
              <input type="date" value={prazoInicio} onChange={e => setPrazoInicio(e.target.value)} />
            </div>
            <div>
              <label>Término previsto</label>
              <input type="date" value={prazoFim} onChange={e => setPrazoFim(e.target.value)} />
            </div>
          </div>

          <div className="po-modal-divider" />

          <label>Escritório</label>
          <select
            value={escritorioId}
            onChange={e => { setEscritorioId(e.target.value); setContatoId(""); }}
          >
            <option value="">Selecione um escritório...</option>
            {escritorios.map(e => (
              <option key={e.id} value={e.id}>{e.nome_escritorio}</option>
            ))}
          </select>

          {membrosDoEscritorio.length > 0 && (
            <>
              <label>Contato responsável</label>
              <select value={contatoId} onChange={e => setContatoId(e.target.value)}>
                <option value="">Selecione um projetista...</option>
                {membrosDoEscritorio.map(m => (
                  <option key={m.id} value={m.id}>{m.nome}</option>
                ))}
              </select>
            </>
          )}

          <div className="po-modal-divider" />

          <label>Responsável</label>
          <select value={responsavelId || ""} onChange={e => setResponsavelId(e.target.value || null)}>
            <option value="">Sem responsável definido</option>
            {membros.map(m => (
              <option key={m.id} value={m.id}>{m.nickname || "Sem nome"}</option>
            ))}
          </select>
        </div>

        <div className="po-modal-footer">
          <button className="po-modal-cancelar" onClick={onClose}>Cancelar</button>
          <button className="po-modal-salvar" onClick={handleSalvar} disabled={salvando}>
            {salvando ? "Salvando..." : "Criar projeto"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ============================================================
// Modal: Editar Projeto
// ============================================================
function EditarProjetoModal({ projeto, campoId, donoContainerId, membros = [], onClose, onAtualizado }) {
  const [nome, setNome] = useState(projeto.nome || "");
  const [icone, setIcone] = useState(projeto.icone || "arquitetura");
  const [etapa, setEtapa] = useState(projeto.etapa || "");
  const [status, setStatus] = useState(projeto.status || "em_analise");
  const [valorTotal, setValorTotal] = useState(projeto.valor_total || "");
  const [prazoInicio, setPrazoInicio] = useState(projeto.prazo_inicio || "");
  const [prazoFim, setPrazoFim] = useState(projeto.prazo_fim || "");
  const [responsavelId, setResponsavelId] = useState(projeto.responsavel_id || null);

  const [escritorios, setEscritorios] = useState([]);
  const [escritorioId, setEscritorioId] = useState(projeto.escritorio_id ? String(projeto.escritorio_id) : "");
  const [membrosDoEscritorio, setMembrosDoEscritorio] = useState([]);
  const [contatoId, setContatoId] = useState(projeto.escritorio_contato_id ? String(projeto.escritorio_contato_id) : "");

  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    const carregar = async () => {
      if (!donoContainerId) return;
      const { data } = await supabase
        .from("escritorios_projetistas")
        .select("*, escritorio_membros(*)")
        .eq("container_id", donoContainerId)
        .order("nome_escritorio");
      setEscritorios(data || []);
    };
    carregar();
  }, [donoContainerId]);

  useEffect(() => {
    const esc = escritorios.find(e => e.id === Number(escritorioId));
    setMembrosDoEscritorio(esc?.escritorio_membros || []);
  }, [escritorioId, escritorios]);

  const handleSalvar = async () => {
    if (!nome.trim()) { alert("Digite o nome do projeto."); return; }
    setSalvando(true);
    try {
      const payload = {
        nome: nome.trim(),
        icone,
        etapa: etapa.trim() || "Não iniciado",
        status,
        valor_total: valorTotal ? Number(valorTotal) : 0,
        prazo_inicio: prazoInicio || null,
        prazo_fim: prazoFim || null,
        escritorio_id: escritorioId ? Number(escritorioId) : null,
        escritorio_contato_id: contatoId ? Number(contatoId) : null,
        responsavel_id: responsavelId,
      };

      const { data: atualizado, error } = await supabase
        .from("projetos_obra")
        .update(payload)
        .eq("id", projeto.id)
        .select(`
          *,
          escritorios_projetistas ( id, nome_escritorio, tipo_projetos ),
          escritorio_membros:escritorio_contato_id ( id, nome, telefone, email, registro_profissional )
        `)
        .single();
      if (error) throw error;

      onAtualizado(atualizado);
    } catch (err) {
      console.error("Erro ao atualizar projeto:", err);
      alert("Erro ao atualizar projeto: " + err.message);
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div className="po-modal-overlay" onClick={onClose}>
      <div className="po-modal-content" onClick={e => e.stopPropagation()}>
        <div className="po-modal-header">
          <h3>Editar projeto</h3>
          <button onClick={onClose}><FaTimes /></button>
        </div>

        <div className="po-modal-body">
          <label>Nome do projeto</label>
          <input type="text" value={nome} onChange={e => setNome(e.target.value)} autoFocus />

          <label>Ícone / Disciplina</label>
          <div className="po-icone-grid">
            {Object.entries(ICONES_PROJETO).map(([key, { label, Icon, color }]) => (
              <button
                key={key}
                type="button"
                className={`po-icone-opcao${icone === key ? " po-icone-opcao--ativa" : ""}`}
                style={{ "--icone-cor": color }}
                onClick={() => setIcone(key)}
                title={label}
              >
                <Icon size={16} />
                <span>{label}</span>
              </button>
            ))}
          </div>

          <div className="po-modal-row">
            <div>
              <label>Etapa</label>
              <input type="text" value={etapa} onChange={e => setEtapa(e.target.value)} />
            </div>
            <div>
              <label>Status</label>
              <select value={STATUS_CONFIG[status] ? status : "em_analise"} onChange={e => setStatus(e.target.value)}>
                {Object.entries(STATUS_CONFIG).map(([key, cfg]) => (
                  <option key={key} value={key}>{cfg.label}</option>
                ))}
              </select>
            </div>
          </div>

          <label>Valor total (R$)</label>
          <input type="number" value={valorTotal} onChange={e => setValorTotal(e.target.value)} />

          <div className="po-modal-row">
            <div>
              <label>Início</label>
              <input type="date" value={prazoInicio || ""} onChange={e => setPrazoInicio(e.target.value)} />
            </div>
            <div>
              <label>Término previsto</label>
              <input type="date" value={prazoFim || ""} onChange={e => setPrazoFim(e.target.value)} />
            </div>
          </div>

          <div className="po-modal-divider" />

          <label>Escritório</label>
          <select
            value={escritorioId}
            onChange={e => { setEscritorioId(e.target.value); setContatoId(""); }}
          >
            <option value="">Selecione um escritório...</option>
            {escritorios.map(e => (
              <option key={e.id} value={e.id}>{e.nome_escritorio}</option>
            ))}
          </select>

          {membrosDoEscritorio.length > 0 && (
            <>
              <label>Contato responsável</label>
              <select value={contatoId} onChange={e => setContatoId(e.target.value)}>
                <option value="">Selecione um projetista...</option>
                {membrosDoEscritorio.map(m => (
                  <option key={m.id} value={m.id}>{m.nome}</option>
                ))}
              </select>
            </>
          )}

          <div className="po-modal-divider" />

          <label>Responsável</label>
          <select value={responsavelId || ""} onChange={e => setResponsavelId(e.target.value || null)}>
            <option value="">Sem responsável definido</option>
            {membros.map(m => (
              <option key={m.id} value={m.id}>{m.nickname || "Sem nome"}</option>
            ))}
          </select>
        </div>

        <div className="po-modal-footer">
          <button className="po-modal-cancelar" onClick={onClose}>Cancelar</button>
          <button className="po-modal-salvar" onClick={handleSalvar} disabled={salvando}>
            {salvando ? "Salvando..." : "Salvar alterações"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ============================================================
// Modal: Cadastro de Escritório / Projetistas
// ============================================================
function CadastroProjetistaModal({ donoContainerId, usuarioId, onClose }) {
  const [nomeEscritorio, setNomeEscritorio] = useState("");
  const [tipoProjetos, setTipoProjetos] = useState("");
  const [membros, setMembros] = useState([{ nome: "", telefone: "", email: "", registro_profissional: "" }]);
  const [salvando, setSalvando] = useState(false);
  const [escritorios, setEscritorios] = useState([]);

  const carregarEscritorios = useCallback(async () => {
    if (!donoContainerId) return;
    const { data } = await supabase
      .from("escritorios_projetistas")
      .select("*, escritorio_membros(*)")
      .eq("container_id", donoContainerId)
      .order("nome_escritorio");
    setEscritorios(data || []);
  }, [donoContainerId]);

  useEffect(() => { carregarEscritorios(); }, [carregarEscritorios]);

  const atualizarMembro = (idx, campo, valor) => {
    setMembros(prev => prev.map((m, i) => i === idx ? { ...m, [campo]: valor } : m));
  };

  const adicionarMembro = () => setMembros(prev => [...prev, { nome: "", telefone: "", email: "", registro_profissional: "" }]);
  const removerMembro = (idx) => setMembros(prev => prev.filter((_, i) => i !== idx));

  const handleSalvar = async () => {
    if (!nomeEscritorio.trim()) { alert("Digite o nome do escritório."); return; }
    const membrosValidos = membros.filter(m => m.nome.trim());
    if (membrosValidos.length === 0) { alert("Adicione pelo menos um projetista."); return; }
    setSalvando(true);
    try {
      const { data: escritorio, error: erroEsc } = await supabase
        .from("escritorios_projetistas")
        .insert([{
          nome_escritorio: nomeEscritorio.trim(),
          tipo_projetos: tipoProjetos.trim() || null,
          container_id: donoContainerId,
          created_by: usuarioId,
        }])
        .select().single();
      if (erroEsc) throw erroEsc;

      const { error: erroMembros } = await supabase
        .from("escritorio_membros")
        .insert(membrosValidos.map(m => ({ ...m, escritorio_id: escritorio.id })));
      if (erroMembros) throw erroMembros;

      setNomeEscritorio("");
      setTipoProjetos("");
      setMembros([{ nome: "", telefone: "", email: "", registro_profissional: "" }]);
      carregarEscritorios();
    } catch (err) {
      console.error("Erro ao cadastrar escritório:", err);
      alert("Erro ao cadastrar: " + err.message);
    } finally {
      setSalvando(false);
    }
  };

  const handleExcluirEscritorio = async (id) => {
    if (!window.confirm("Excluir este escritório e seus projetistas?")) return;
    const { error } = await supabase.from("escritorios_projetistas").delete().eq("id", id);
    if (!error) setEscritorios(prev => prev.filter(e => e.id !== id));
  };

  return (
    <div className="po-modal-overlay" onClick={onClose}>
      <div className="po-modal-content" onClick={e => e.stopPropagation()} style={{ width: 520 }}>
        <div className="po-modal-header">
          <h3>Cadastro de projetista</h3>
          <button onClick={onClose}><FaTimes /></button>
        </div>

        <div className="po-modal-body">
          <label>Nome do escritório</label>
          <input type="text" style={{ width: "100%" }} value={nomeEscritorio}
            onChange={e => setNomeEscritorio(e.target.value)} placeholder="Ex: Silva Arquitetura" autoFocus />

          <label>Tipo de projetos</label>
          <input type="text" style={{ width: "100%" }} value={tipoProjetos}
            onChange={e => setTipoProjetos(e.target.value)} placeholder="Ex: Arquitetônico, Estrutural..." />

          <div className="po-modal-divider" />
          <label>Projetistas</label>

          {membros.map((m, idx) => (
            <div key={idx} className="po-novo-projetista-box" style={{ marginBottom: 8 }}>
              <input type="text" placeholder="Nome" value={m.nome}
                onChange={e => atualizarMembro(idx, "nome", e.target.value)} />
              <input type="text" placeholder="Telefone" value={m.telefone}
                onChange={e => atualizarMembro(idx, "telefone", e.target.value)} />
              <input type="email" placeholder="E-mail" value={m.email}
                onChange={e => atualizarMembro(idx, "email", e.target.value)} />
              <input type="text" placeholder="Registro profissional (CREA/CAU)" value={m.registro_profissional}
                onChange={e => atualizarMembro(idx, "registro_profissional", e.target.value)} />
              {membros.length > 1 && (
                <button type="button" className="po-link-btn" onClick={() => removerMembro(idx)}>Remover este projetista</button>
              )}
            </div>
          ))}
          <button type="button" className="po-link-btn" onClick={adicionarMembro}>+ Adicionar outro projetista</button>

          {escritorios.length > 0 && (
            <>
              <div className="po-modal-divider" />
              <label>Escritórios cadastrados</label>
              {escritorios.map(esc => (
                <div key={esc.id} className="po-doc-item">
                  <div style={{ flex: 1 }}>
                    <span className="po-doc-nome">{esc.nome_escritorio}</span>
                    <span className="po-doc-meta">{esc.escritorio_membros?.length || 0} projetista(s)</span>
                  </div>
                  <button className="po-row-menu" onClick={() => handleExcluirEscritorio(esc.id)}><FaTrash size={11} /></button>
                </div>
              ))}
            </>
          )}
        </div>

        <div className="po-modal-footer">
          <button className="po-modal-cancelar" onClick={onClose}>Fechar</button>
          <button className="po-modal-salvar" onClick={handleSalvar} disabled={salvando}>
            {salvando ? "Salvando..." : "Cadastrar escritório"}
          </button>
        </div>
      </div>
    </div>
  );
}